import { render, staticRenderFns } from "./SmartIdPlusModal.vue?vue&type=template&id=d3661922"
import script from "./SmartIdPlusModal.vue?vue&type=script&lang=js"
export * from "./SmartIdPlusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports